// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";
// Assets
import PlaceHolderImg from "../../../../assets/images/protocols/reports/place_holder.png";
import PlaceHolderResponsiveImg from "../../../../assets/images/protocols/reports/place_holder.png";

export const GetWebHandTrackingProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/reports/web/handTracking", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.web.handTracking.MEMOSEQ.id]: {
      img: protocolImg["./memoseq.png"],
      imgResponsive: protocolImg["./memoseq_responsive.png"],
      name: "uppercaseProtocols_memoseqWeb",
      description: "protocols_memoseqWebDescription",
      video: "protocols_memoseqWebVideo",
    },
    [protocols.web.handTracking.MIRROR.id]: {
      img: protocolImg["./mirror.png"],
      imgResponsive: protocolImg["./mirror_responsive.png"],
      name: "uppercaseProtocols_mirror",
      description: "protocols_mirrorDescription",
      video: "protocols_mirrorVideo",
    },
    [protocols.web.handTracking.RECYCLING.id]: {
      img: protocolImg["./recycling.png"],
      imgResponsive: protocolImg["./recycling_responsive.png"],
      name: "uppercaseProtocols_recycling",
      description: "protocols_recyclingDescription",
      video: "protocols_recyclingVideo",
    },
    [protocols.web.handTracking.WHAC_A_MOLE.id]: {
      img: protocolImg["./whac_a_mole.png"],
      imgResponsive: protocolImg["./whac_a_mole_responsive.png"],
      name: "uppercaseProtocols_whackAMole",
      description: "protocols_whackAMoleDescription",
      video: "protocols_whackAMoleVideo",
    },
    [protocols.web.handTracking.FULL_BODY.id]: {
      img: PlaceHolderImg,
      imgResponsive: PlaceHolderResponsiveImg,
      name: "Full body",
      description: "",
      video: "",
    },
    [protocols.web.handTracking.BALANCE.id]: {
      img: PlaceHolderImg,
      imgResponsive: PlaceHolderResponsiveImg,
      name: "uppercaseProtocols_balance",
      description: "protocols_balanceDescription",
      video: "protocols_balanceVideo",
    },
    [protocols.web.handTracking.SEQUENCES.id]: {
      img: protocolImg["./sequences.png"],
      imgResponsive: protocolImg["./sequences_responsive.png"],
      name: "uppercaseProtocols_sequences",
      description: "protocols_sequencesDescription",
      video: "protocols_sequencesVideo",
    },
    [protocols.web.handTracking.WORDS.id]: {
      img: protocolImg["./words.png"],
      imgResponsive: protocolImg["./words_responsive.png"],
      name: "uppercaseProtocols_words",
      description: "protocols_wordsDescription",
      video: "protocols_wordsVideo",
    },
    [protocols.web.handTracking.OBJECTS_RAIN.id]: {
      img: protocolImg["./objectsRain.png"],
      imgResponsive: protocolImg["./objectsRain_responsive.png"],
      name: "uppercaseProtocols_objectsRain",
      description: "protocols_objectsRainDescription",
      video: "protocols_objectsRainVideo",
    },
  };

  return protocolsData[Number(protocolId)];
};
